exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".imgalign-editor[data-v-76117910] {\n  display: inline-grid;\n  grid-gap: 0.5rem;\n}\n.none-editor[data-v-76117910] {\n  display: inline-grid;\n  grid-template-columns: 1fr 1fr;\n  grid-gap: 0.25rem;\n}\n", ""]);

// exports
